import type { AxiosError } from "axios";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export const FORBIDDEN_MESSAGE =
  "El rol del usuario no tiene permisos para esta operación.";

export function isForbiddenError(error: unknown): boolean {
  const axiosError = error as AxiosError | undefined;
  return axiosError?.response?.status === 403;
}

export function notifyForbidden(): void {
  Swal.fire({
    text: FORBIDDEN_MESSAGE,
    icon: "error",
    buttonsStyling: false,
    confirmButtonText: "Cerrar",
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
}
